import React, { useMemo } from 'react';
import { FaTimes } from 'react-icons/fa';
import { useRecorderPanel } from '../../context/RecorderPanelContext';
import { useAuth } from '../../context/AuthContext';
import Recorder from '../../Dictaphone/Recorder';
import LiveRecorderPage from '../../Dictaphone/LiveRecorderPage';
import HoverTooltip from '../tooltips/HoverTooltip';
import './RecorderSidePanel.css';

export default function RecorderSidePanel() {
  const { isOpen, panelMode, closePanel, togglePanel, isWebOnly } = useRecorderPanel();
  const { profile } = useAuth();

  // Check if user has Gold or Enterprise subscription for Live mode access
  const isGoldOrEnterprise = useMemo(() => {
    return Boolean(
      profile?.isGoldOrEnterprise === true ||
      profile?.isgoldorenterprise === true ||
      profile?.subscription?.planType === 'gold' ||
      profile?.subscription?.planType === 'enterprise' ||
      profile?.subscription?.plan === 'gold' ||
      profile?.subscription?.plan === 'enterprise'
    );
  }, [profile]);

  // Don't render on non-web platforms
  if (!isWebOnly) {
    return null;
  }

  return (
    <>
      {/* Backdrop for mobile overlay mode */}
      <div
        className={`recorder-side-panel-backdrop ${isOpen ? 'visible' : ''}`}
        onClick={closePanel}
      />

      {/* Side panel */}
      <div className={`recorder-side-panel ${isOpen ? 'open' : ''}`}>
        {/* Header with tabs and close button */}
        <div className="recorder-side-panel-header">
          <div className="recorder-side-panel-tabs">
            <button
              className={`recorder-side-panel-tab ${panelMode === 'recorder' ? 'active' : ''}`}
              onClick={() => togglePanel('recorder')}
            >
              Dictaphone
            </button>
            {!isGoldOrEnterprise ? (
              <HoverTooltip text="Nécessite un abonnement Gold ou Enterprise" position="bottom">
                <button
                  className="recorder-side-panel-tab"
                  disabled
                >
                  Dictée Live
                </button>
              </HoverTooltip>
            ) : (
              <button
                className={`recorder-side-panel-tab ${panelMode === 'live' ? 'active' : ''}`}
                onClick={() => togglePanel('live')}
              >
                Dictée Live
              </button>
            )}
          </div>
          <button
            className="recorder-side-panel-close"
            onClick={closePanel}
            title="Fermer"
          >
            <FaTimes />
          </button>
        </div>

        {/* Content area */}
        <div className="recorder-side-panel-content">
          {isOpen && (
            panelMode === 'live' && isGoldOrEnterprise ? (
              <LiveRecorderPage />
            ) : (
              <Recorder />
            )
          )}
        </div>
      </div>
    </>
  );
}
